import * as React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";

import { inputClasses, Input } from "@mui/base/Input";

import { styled } from "@mui/system";
import { COLORS } from "../../Utils/COLORS";

const CustomInput = React.forwardRef(function CustomInput(props, ref) {
  const { slots, ...other } = props;
  return (
    <Input
      slots={{
        root: StyledInputRoot,
        input: StyledInputElement,
        ...slots,
      }}
      {...other}
      ref={ref}
    />
  );
});

CustomInput.propTypes = {
  /**
   * The components used for each slot inside the InputBase.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType,
    textarea: PropTypes.elementType,
  }),
};

export default function InputAdornments({
  type,
  placeholder,
  value,
  onChange,
}) {


  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        gap: 2,
      }}
    >
      <CustomInput
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        endAdornment={<InputAdornment>Gm</InputAdornment>}
      />
    </Box>
  );
}

const blue = {
  100: COLORS.primary,
  200: COLORS.primary,
  400: COLORS.primary,
  500: COLORS.primary,
  600: COLORS.primary,
};

const grey = {
  50: "#F3F6F9",
  100: "#E7EBF0",
  200: "#E0E3E7",
  300: "#CDD2D7",
  400: "#B2BAC2",
  500: "#A0AAB4",
  600: "#6F7E8C",
  700: "#3E5060",
  800: "#2D3843",
  900: "#1A2027",
};

const StyledInputRoot = styled("div")(
  ({ theme }) => `
  width: 100%;

  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  padding: 10px 20px;
  border-radius: 4px;
  color: ${theme.palette.mode === "dark" ? grey[300] : grey[500]};
  background: ${theme.palette.mode === "dark" ? grey[900] : "#fff"};
  border: 1px solid ${theme.palette.mode === "dark" ? grey[700] : grey[200]};
  
  display: flex;
  align-items: center;
  justify-content: center;


  &.${inputClasses.focused} {
    border-color: ${blue[400]};
   
  }

  &:hover {
    border-color: ${blue[400]};
  }

  // firefox
  &:focus-visible {
    outline: 0;
  }
`
);

const StyledInputElement = styled("input")(
  ({ theme }) => `

  font-weight: 400;
  line-height: 1.5;
  flex-grow: 1;
  color: ${theme.palette.mode === "dark" ? grey[300] : grey[900]};
  background: inherit;
  border: none;
  border-radius: inherit;

  outline: 0;
`
);


const InputAdornment = styled("div")`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;
